import { configureStore } from '@reduxjs/toolkit';
import { configSlice } from './slices/config';
import { locationSlice } from './slices/location';
import { NODE_ENVIROMENT_VAR } from '../constants/environments';

export const store = configureStore({
  reducer: {
    config: configSlice.reducer,
    location: locationSlice.reducer,
  },
  devTools: process.env.NODE_ENV !== NODE_ENVIROMENT_VAR.pro,
});

export const dispatch = store.dispatch;
